import React from "react"

export default function SectionHeading({
  title,
  subtitle,
  actions = null
}) {
  return (
    <div
      style={{
        marginBottom: 12,
        display: "flex",
        justifyContent: "space-between",
        gap: 10,
        alignItems: "flex-start",
        flexWrap: "wrap"
      }}
    >
      <div>
        <div
          style={{
            fontSize: 17,
            fontWeight: 900,
            color: "#0f172a"
          }}
        >
          {title}
        </div>

        {subtitle ? (
          <div
            style={{
              fontSize: 12,
              color: "#64748b",
              marginTop: 3
            }}
          >
            {subtitle}
          </div>
        ) : null}
      </div>

      {actions}
    </div>
  )
}